:host{display:flex;flex:1;background-color:#fff;padding:20px 50px;box-shadow:0 -8px 8px -8px #0003;justify-content:space-between}.iconf-btn-blank{color:#8c8f93}
/*# sourceMappingURL=system-selection-footer.component-DDW53B3P.css.map */
